<template>
  <div>
    <personal-form
      :title="`${local.personInformation.title} ( ${partyTypeRole} ${local.common.casePartyRoles.inheritor} )`"
      :form-model="formModel"
      :required="required"
    ></personal-form>

    <inheritor-form
      v-if="showInheritorForm"
      :form-model="formModel"
      @inheritor-validated="onInheritorValidated"
    ></inheritor-form>
  </div>
</template>

<script>
import InheritorForm from './forms/inheritor-form.vue';
import PersonalForm from './forms/personal-form.vue';
import { casePartyRoleByIdEnum, partyTypeEnum, sharedAssetTypeEnum } from '@/helpers/enum.js';

export default {
  inject: ['$validator'],
  components: {
    InheritorForm,
    PersonalForm,
  },
  props: ['formModel', 'required'],
  data() {
    return { isInheritorValidated: false };
  },
  computed: {
    partyTypeRole() {
      var partyRoleValue = this.formModel.casePartyRole !== 0 ? this.formModel.casePartyRole : this.formModel.relatedPartiesInfo[0].casePartyRole;
      return (
        this.local.common.casePartyRoles[casePartyRoleByIdEnum[partyRoleValue]]
      );
    },
    showInheritorForm() {
      return !((this.formModel.partyType === partyTypeEnum.liquidator || this.formModel.partyType === partyTypeEnum.judicialGuard) && this.formModel.sharedAssetType === sharedAssetTypeEnum.inheritance);
    },
  },
  methods: {
    onInheritorValidated(isValid) {
      this.isInheritorValidated = isValid;
      this.$emit('inheritor-validation-changed', isValid);
    },
  },
};
</script>

<style lang="scss" scoped></style>
